import React from 'react';

export const ProactivePrescriptionDisabledBanner = () => {
  return (
    <div className="notifications d-flex rounded justify-content-center align-items-center font-weight-bold pt-1 me-1 ms-1 mb-3">
      <span className="pe-2">
        <i className="fa fa-exclamation-triangle"></i>
      </span>
      <span className="alert-header me-1">PROACTIVE PRESCRIBING DISABLED</span>
    </div>
  );
};
